import { b2x } from '@b2x/react/src';

import { Box } from '../Box';
import { GenericFormContentType } from '../contentTypes';
import { Page } from './Page';

export interface ForgotPasswordPageProps {}

export const ForgotPasswordPage = (props: ForgotPasswordPageProps) => {
  const content = b2x.useContent<GenericFormContentType>('FORGOT_PASSWORD_FORM_CONTENT');

  return (
    <Page>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-5">
            <Box>
              <div className="mb-4">
                <h2 className="text-primary text-center mb-3">{b2x.formatHtml(content?.body.title)}</h2>
                <p>{b2x.formatHtml(content?.body.subtitle)} </p>
              </div>
              <b2x.ForgotPasswordFormHelper className="mb-4">
                {({ fieldsHelper }) => (
                  <>
                    <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
                      <b2x.TextInput {...fieldsHelper.email.textInput} />
                    </b2x.FormGroup>
                    <div className="d-grid">
                      <b2x.Button {...fieldsHelper.buttons.submit} />
                    </div>
                  </>
                )}
              </b2x.ForgotPasswordFormHelper>
            </Box>
          </div>
        </div>
      </div>
    </Page>
  );
};
